import script from "./agents-build-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./agents-build-group.vue?vue&type=script&setup=true&lang=ts"

import "./agents-build-group.vue?vue&type=style&index=0&id=044dff96&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044dff96"]])

export default __exports__